import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";
const Exprience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col xl:flex-row gap-10 lgl:gap-10"
    >
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px] uppercase">
            2011-2023
          </p>
          <h2 className="text-3xl md:text-4xl font-bold">
            Professional Experiences
          </h2>
        </div>
        <div
          className="mt-6 w-full h-[1100px] lgl:w-[550px] lgl:ml-20 border-l-[6px] border-black 
        border-opacity-30 flex flex-col gap-10"
        >
          <ResumeCard
            title="Network Engineer"
            subTitle="University of Malawi (UNIMA) (2018-2023)"
            results="UNIMA"
            des="One of my biggest professional accomplishments has been
            learning Network Engineering at Universisty of Malawi. Lessons
             in theory and practice were being taught to us."
          />
          <ResumeCard
            title="Web Developer Intern"
            subTitle="International Telecommunications Union (ITU) (Present)"
            results="Remote"
            des="I've been given the go-ahead to begin my internship at TSB department.
            Under the direction of the department manager, Mr. Thomas, I am working remotely."
          />
          <ResumeCard
            title="Graphic Designer"
            subTitle="Macheda Graphics (2018-Present)"
            results="ZuzuTech"
            des="One of Malawi's top graphic design firms is Macheda Graphics.
            I am a senior graphic designer and a manager."
          />
          <ResumeCard
            title="Research Assistant"
            subTitle="Institute of Public Opinion & Reseach (IPOR) (2022)"
            results="IPOR"
            des="A reputable research organization is IPOR. In 2022, I took part in the 
            GESD study project by gathering information on Mzimba and Likoma Island."
          />
        </div>
      </div>
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px] uppercase">
            2011-2023
          </p>
          <h2 className="text-3xl md:text-4xl font-bold">Life Experience</h2>
        </div>
        <div
          className="mt-6 w-full lgl:w-[550px] lgl:h-[1100px] h-auto border-l-[6px] border-black 
          border-opacity-30 flex flex-col gap-10"
        >
          <ResumeCard
            title="Publicity Secretary of Comsoc"
            subTitle="Computer Science Society (2022-2023)"
            results="UNIMA"
            des="As the publicity secretary for this sizable group, it is an honor 
            for me to assume the responsibilities. I've gained a great deal of
             knowledge about the computing department at the University
             of Malawi's larger community, as well as how to impart that knowledge."
          />
          <ResumeCard
            title="Sports"
            subTitle="Manchester United Fan (2008-Present)"
            results="Malawi"
            des="My favorite team is Manchester United. I first subscribed in 2008. 
            Sir Alex Ferguson won the EPL and UCL at that time. I have endured a lot
             as a devoted fan over the past five years without receiving a trophy,
              but I'm still holding out hope for the best. I never gave up. My favorite place to 
            watch football is Cafe B at Unima. I enjoy the atmosphere of that room."
          />
          <ResumeCard
            title="Entrepreneurship"
            subTitle="Macheda Online Shop(2021-2022)"
            results="Online"
            des="I started out by buying items from South Africa and 
            selling them, such as laptop bags, outfits, shoes, and purses.
             The outcome, however, wasn't what I had hoped for. In light of 
             this, running a business requires 
            being risk-averse and strong-willed.
             Money should work for you, not the other way around."
          />
          <ResumeCard
            title="Fast learner"
            subTitle="Internet (Present)"
            results="Internet"
            des="Every day, I enjoy picking up new skills,
             and I don't take too long to learn the material.
              I'm always up for a challenge, and I make sure 
              that I grasp both theory and practical application 
            so that I am comfortably use the tools."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Exprience;
